export class ChartConfig {
    name: string;
    guid: string;
    subtitle: string;
    description: string;
    type: ChartType;
    template: ChartTemplate;
    updatedBy: string;
    updatedDate: Date;
    dataUpdatedBy: string;
    dataUpdatedDate: Date;
    systemUpdatedDate: Date;
    createdBy: string;
    createdDate: Date;
    hasAccess: boolean;
    hideTitle: boolean = false;
    hideLegend: boolean = false;
    hideLabels: boolean = false;
    tags?: any[] = [];
    owner: any;
    ispublished: boolean;
}

export class Chart {
    id: number;
    guid: string;
    name: string;
    description: string;
    subtitle: string;
    data: ChartData;
    chartType: ChartType = ChartType.chart;
    version: number = 2;
    dataType: ChartDataType = ChartDataType.static;
    template: ChartTemplate;
    linkedChart: string;
    isPublished: boolean = false;
    tags?: any[];
    securityGroups?: any[];
    createdBy: string;
    createdDate: Date;
    updatedBy: string;
    updatedDate: Date;
    systemUpdatedDate?: Date;
    chartData:ChartDataDto;
    hasAccess: boolean = false;
    canEdit: boolean = false; //This field is not filled by every api call so use with caution
    workspace: any;
    owner: any;
    

    constructor(json?: any) {
        if (!json) {
            this.template = new ChartTemplate();
            return;
        }
        this.id = json.id;
        this.guid = json.guid;
        this.name = json.name;
        this.description = json.description;
        this.subtitle = json.subtitle;
        this.chartType = json.chartType;
        this.version = json.version;
        this.dataType = json.dataType;
        this.template = new ChartTemplate(json.template);
        this.linkedChart = json.linkedChart;
        this.isPublished = json.isPublished;
        this.hasAccess = json.hasAccess;
        this.canEdit = json.canEdit;
        this.owner = json.owner;

        if (json.chartData) {
            this.chartData = new ChartDataDto(json.chartData)
        }

        if (json.tags) {
            this.tags = json.tags;
        }

        if (json.securityGroups) {
            this.securityGroups = json.securityGroups;
        }

        this.createdBy = json.createdBy;
        this.createdDate = json.createdDate ? new Date(json.createdDate) : new Date();
        this.updatedBy = json.updatedBy;
        this.updatedDate = json.updatedDate ? new Date(json.updatedDate) : new Date();
        if(json.workspace){
            this.workspace = json.workspace;
        }
    }
}
export class TextCard extends Chart {
    public data: ChartData;

    constructor(json?: any) {
        super(json)
        if (json == null) {
            return;
        }
        this.data = new ChartData();
    }
}

export class ChartDataDto {
    guid: string;
    chartName: string;
    chartDesc: string;
    user: string;
    data: ChartData;
    updatedDate: Date;
    updatedBy: string
    systemUpdatedDate?: Date;

    constructor(data?: any) {
        if (!data) return;
        this.guid = data.guid;
        this.chartName = data.chartName;
        this.chartDesc = data.chartDesc;
        this.user = data.user;
        this.data = data.data;
        this.updatedBy = data.updatedBy;
        //this.updatedDate = data.updatedDate ? new Date(this.updatedDate) : new Date();
        this.updatedDate = data.updatedDate;
        this.systemUpdatedDate = data.systemUpdatedDate;
    }
}

export class ChartData {
    filteredData: FilteredData[];
    figures: Figure[];
    textData: TextData;
    gaugeData: GaugeData;
    systemUpdatedDate?: Date;
    
    constructor(json: any = null) {
        this.filteredData = new Array<FilteredData>();
        this.figures = new Array<Figure>();
        if (json == null) {
            return;
        }

        var filteredData = json.filteredData != null ? json.filteredData : json.FilteredData;
        if (filteredData) {
            filteredData.forEach(fData => {
                this.filteredData.push(new FilteredData(fData));
            })
        }

        var figures = json.figures != null ? json.figures : json.Figures;
        if (figures) {
            figures.forEach(figure => {
                this.figures.push(new Figure(figure));
            })
        }

        var textData = (json.textData != null ? json.textData : json.TextData);
        if(textData){
            this.textData = new TextData(textData);
        }else{
            this.textData = new TextData();
        }

        var gaugeData = (json.gaugeData != null ? json.gaugeData : json.GaugeData);
        if(gaugeData){
            this.gaugeData = new GaugeData(gaugeData);
        }else{
            this.gaugeData = new GaugeData();
        }
        this.systemUpdatedDate = json.systemUpdatedDate;
    }
}

export class BatchChartUpdate {
    updated: any [];
    errors: any;
    updatedDtos: ChartDataDto [];

    constructor(json: any = null) {
        if(json !== null) {
            this.updatedDtos = new Array<ChartDataDto>();
            this.updated = json.updated;
            this.errors = json.errors;
            json.updatedDtos.forEach(chart => {
                this.updatedDtos.push(new ChartDataDto(chart));
            });
        }
    }
}

export class ChartTemplate {
    template: ChartTemplateType = ChartTemplateType.cartesianHorizontalCategories;
    series: Series[] = [];
    palette: string[] = [];

    constructor(data?: any) {
        if (!data) return;

        if (typeof data === 'string') {
            data = JSON.parse(data);
        }

        this.template = data.template;
        if (data.series && Array.isArray(data.series)) data.series.forEach(d => this.series.push(new Series(d)));
        if (data.palette && Array.isArray(data.palette)) data.palette.forEach(p => this.palette.push(p));
    }
}

export class Series {
    public id: number;
    public type: SeriesType = SeriesType.bar;
    public fillColor: string = '';
    public strokeType: StrokeType = StrokeType.solid;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        this.id = json.id != null ? json.id : json.Id;
        this.type = json.type != null ? json.type : json.Type;
        this.fillColor = json.fillColor != null ? json.fillColor : json.FillColor;
        if (!this.fillColor) this.fillColor = json.color != null ? json.color : json.Color;
        this.strokeType = json.strokeType != null ? json.strokeType : json.StrokeType;
    }
}

export class TelerikData {
    public categories: Array<any>;
    public series: Array<SeriesData>;
    constructor() {
        this.categories = new Array<any>();
        this.series = new Array<SeriesData>();
    }
}

export class FilteredData {
    public ordinal: number;
    public name: string;
    public data: Array<SeriesData>; //just for chart
    public annotations: Array<Annotation> //just for chart
    public grid: Grid;
    public gauge: GaugeData;
    public textData: TextData;
    public boxPlot: Array<BoxPlotData>;
    constructor(json: any = null) {
        this.data = new Array<SeriesData>();
        this.annotations = new Array<Annotation>();
        this.boxPlot = new Array<BoxPlotData>();
        if (json == null) {
            return;
        }

        this.ordinal = json.ordinal != null ? json.ordinal : json.Ordinal;
        this.name = json.name != null ? json.name : json.Name;
        var grid = json.grid != null ? json.grid : json.Grid;
        this.grid = new Grid(grid);
        var data = json.data != null ? json.data : json.Data;
        if (data) {
            data.forEach(data => {
                this.data.push(new SeriesData(data));
            });
        }

        var gauge = json.gauge != null ? json.gauge : json.Gauge ? json.Gauge : json.gaugeData;
        this.gauge = new GaugeData(gauge);

        var boxPlots = json.boxPlot != null ? json.boxPlot : json.BoxPlot;
        if(boxPlots){
            boxPlots.forEach(boxPlot => {
                this.boxPlot.push(new BoxPlotData(boxPlot));
            });  
        } 

        var textData = json.textData != null ? json.textData : json.TextData;
        this.textData = new TextData(textData);

        var annotations = json.annotations != null ? json.annotations : json.Annotation;
        if (annotations) {
            annotations.forEach(annotation => {
                this.annotations.push(new Annotation(annotation));
            });
        }
    }
}


//Grid Card
export class Grid {
    public columnDefinitions: Array<ColumnDefinitions>;
    public rows: Array<Row>;

    constructor(json: any = null) {
        this.columnDefinitions = new Array<ColumnDefinitions>();
        this.rows = new Array<Row>();
        if (json == null) {
            return;
        }

        var columnDefinitions = json.columnDefinitions != null ? json.columnDefinitions : json.ColumnDefinitions;
        if (columnDefinitions) {
            columnDefinitions.forEach(point => {
                this.columnDefinitions.push(new ColumnDefinitions(point));
            });
        }

        var rows = json.rows != null ? json.rows : json.Rows;
        if (rows) {
            rows.forEach(point => {
                this.rows.push(new Row(point));
            });
        }
    }
}

export class ColumnDefinitions {
    public headerText: string;
    public isVisible: boolean = true;
    public headerStyle: HeaderStyle;
    public cellStyle: CellStyle;

    constructor(json: any = null) {
        if (json == null) {
            return;
        }

        this.headerText = json.headerText != null ? json.headerText : json.HeaderText;
        this.isVisible = json.isVisible != null ? json.isVisible : json.IsVisible;
        this.headerStyle = new HeaderStyle(json.headerStyle != null ? json.headerStyle : json.HeaderStyle);
        this.cellStyle = new CellStyle(json.cellStyle != null ? json.cellStyle : json.CellStyle);
    }
}

export class Row {
    public isVisible: boolean = true;
    public cells: Array<Cell>;


    constructor(json: any = null) {

        this.cells = new Array<Cell>();
        if (json == null) {
            return;
        }

        this.isVisible = json.isVisible != null ? json.isVisible : json.IsVisible;
        var cells = json.cells != null ? json.cells : json.Cells;
        if (cells) {
            cells.forEach(cell => {
                this.cells.push(new Cell(cell));
            });
        }
    }
}

export class Cell {
    public value: string;
    public style: CellStyle;


    constructor(json: any = null) {

        this.value = json.value != null ? json.value : json.Value;
        this.style = new CellStyle(json.style != null ? json.style : json.Style);

    }
}

export class CellStyle {
    public textColor: string;
    public horizontalTextAlignment: TextAlignment;
    public fontSize: number;
    public fontAttributes: FontAttributes;

    constructor(json: any = null) {
        if (json == null) return;
        var textColor = json.textColor ? json.textColor : json.TextColor;
        this.textColor = (textColor ? textColor : "");
        var fontSize = json.fontSize ? json.fontSize : json.FontSize;
        this.fontSize = (fontSize ? fontSize : "12");
        var fontAttributes = json.fontAttributes ? json.fontAttributes : json.FontAttributes;
        this.fontAttributes = (fontAttributes ? fontAttributes : FontAttributes.None);
        var horizontalTextAlignment = json.horizontalTextAlignment ? json.horizontalTextAlignment : json.HorizontalTextAlignment;
        this.horizontalTextAlignment = (horizontalTextAlignment ? horizontalTextAlignment : TextAlignment.Start);
    }

    public toNgStyle(): NgCssStyle {
        let style = new NgCssStyle();
        style.color = (this.textColor ? this.textColor : 'initial');
        style['font-size'] = (this.fontSize ? this.fontSize + "px" : 'initial');
        if (this.fontAttributes == FontAttributes.Bold) {
            style['font-weight'] = 'bold';
        }
        if (this.fontAttributes == FontAttributes.Italics) {
            style['font-style'] = 'italic';
        }
        switch (this.horizontalTextAlignment) {
            case TextAlignment.Start:
                style['text-align'] = 'start';
                break;
            case TextAlignment.Center:
                style['text-align'] = 'center';
                break;
            case TextAlignment.End:
                style['text-align'] = 'end';
                break;
            default:
                break;
        }
        return style;
    }
}

export class HeaderStyle extends CellStyle {
    public backgroundColor: string;
    public borderColor: string;
    public borderThickness: number;

    constructor(json?: any) {
        super(json)
        if (json == null) {
            return;
        }
        var backgroundColor = json.backgroundColor != null ? json.backgroundColor : json.BackgroundColor;
        this.backgroundColor = (backgroundColor != null ? backgroundColor : "");
        var borderColor = json.borderColor != null ? json.borderColor : json.BorderColor;
        this.borderColor = (borderColor != null ? borderColor : "");
        var borderThickness = json.borderThickness != null ? json.borderThickness : json.BorderThickness;
        this.borderThickness = (borderThickness != null ? borderThickness : "0");
    }

    public toNgStyle(): NgCssStyle {
        let style: NgCssStyle = super.toNgStyle(); //get the CellStyle (parent)
        style['background-color'] = (this.backgroundColor != null ? this.backgroundColor : 'initial');
        style['border-color'] = (this.borderColor != null ? this.borderColor : 'initial'),
            style['border-width'] = (this.borderThickness != null ? this.borderThickness + "px" : 'initial')
        return style;
    }
}

//Represents a class as readable by Angular's NgStyle directive
export class NgCssStyle {
    //Cell styles
    public 'color': string;
    public 'font-size': string;
    //Header styles
    public 'background-color': string;
    public 'border-color': string;
    public 'border-width': string;
    public 'font-weight': string;
    public 'font-style': string;
}

//Contains the properties that Kendo Grid needs for each column
export class KendoColumn {
    //Column Text
    public title: string;
    //Name of the Column to show (like an Id)
    public field: string;
    //Object representation of a CSS style as required by the NgStyle directive
    public headerStyle: NgCssStyle;
}

// enum grid
export enum TextAlignment {
    Start = 0,
    Center = 1,
    End = 2
}

export enum FontAttributes {
    None = 0,
    Bold = 1,
    Italics = 2
}

// end of enum

// end of gridCard

export class SeriesData {
    public seriesId: number;
    public name: string;
    public points: Array<Point>;
    public fillColor: string;
    public strokeType: StrokeType;
    public typeString: string;
    public lineStyle: any;
    public style: any;
    public stacked: boolean = false;
    public dataPoints: Array<any>;

    constructor(json: any = null) {
        this.points = new Array<Point>();
        if (json == null) {
            return;
        }

        this.seriesId = json.seriesId != null ? json.seriesId : json.SeriesId;
        this.name = json.name != null ? json.name : json.Name;

        var points = json.points != null ? json.points : json.Points;
        if (points) {
            points.forEach(point => {
                this.points.push(new Point(point));
            });
        }
    }
}

export class Point {
    public category: any;
    public value: any;
    public name: string;
    public area: number;
    public fillColor: string;

    constructor(json: any = null) {
        if (json == null) {
            return;
        }

        var category = json.category != null ? json.category : json.Category;
        this.category = parseInt(category);
        if (isNaN(this.category))
            this.category = category;

        var value = json.value != null ? json.value : json.Value;
        this.value = parseFloat(value);
        if (isNaN(this.value))
            this.value = value;
        this.name = json.name != null ? json.name : json.Name;
        this.area = json.area != null ? json.area : json.Area;
    }
}

export class Annotation {
    public seriesId: number;
    public type: AnnotationType;
    public category: string;
    public categoryEnd: string;
    public value: string;
    public valueEnd: string;
    public text: string;
    public color: string;

    constructor(json: any = null) {
        if (json == null) {
            return;
        }

        this.seriesId = json.seriesId != null ? json.seriesId : json.SeriesId;
        this.type = json.type != null ? json.type : json.Type;
        this.category = json.category != null ? json.category : json.Category;
        this.categoryEnd = json.categoryEnd != null ? json.categoryEnd : json.CategoryEnd;
        this.value = json.value != null ? json.value : json.Value;
        this.valueEnd = json.valueEnd != null ? json.valueEnd : json.ValueEnd;
        this.text = json.text != null ? json.text : json.Text;
        this.color = json.color != null ? json.color : json.Color;
    }
}

export class Figure {
    public icon: FigureIcon = FigureIcon.undefined;
    public style: FigureStyle = FigureStyle.undefined;
    public title: string = null;
    public subtitle: string;

    // public iconString: string = null;

    constructor(json?: any) {
        if (json == null) {
            return;
        }

        this.icon = json.icon != null ? json.icon : json.Icon;
        this.style = json.style != null ? json.style : json.Style;
        this.title = json.title != null ? json.title : json.Title;
        this.subtitle = json.subtitle != null ? json.subtitle : json.Subtitle;

    }

    public get iconString(): string {

        switch (this.icon) {
            case FigureIcon.trendingFlat:
                return "trending_flat";
            case FigureIcon.trendingUp:
                return "trending_up";
            case FigureIcon.trendingDown:
                return "trending_down";
            default:
                return "none";
        }
    }
}

export class TextData {
    public text: string;
    public color: string;
    public size: string;
    public sizePx: number;

    constructor(json?: any) {
        if (json == null) {
            this.text = "";
            this.color = "";
            this.size = "";
            this.sizePx = 20;
            return;
        }

        this.text = json.text != null ? json.text : json.Text;
        this.color = json.color != null ? json.color : json.Color;
        this.size = json.size != null ? json.size : json.Size;
        this.setSizePx();
    }

    setSizePx() {
        let num: number;
        switch (this.size) {
            case "S": num = 20; break;
            case "M": num = 40; break;
            case "L": num = 60; break;
            case "XL": num = 80; break;
            default: num = 20; break;
        }
        this.sizePx = num;
    }
}

// box and whisker data
export class BoxPlotData {
    public lowerVal: number;
    public quartile1: number;
    public median: number;
    public quartile3: number;
    public upperVal: number;
    public mean: number;
    public outliers: number[];
    public categoryField: string;
    public color: string;

    constructor(json?: any){
        if(json == null || json == undefined){
            this.lowerVal= 0,
            this.quartile1= 0,
            this.median= 0,
            this.quartile3= 0,
            this.upperVal= 0,
            this.mean= 0,
            this.outliers= [0, 1],
            this.categoryField= '',
            this.color = '#FFFFFF'
            return;
        }
        this.lowerVal = json.lowerVal != null ? json.lowerVal: json.LowerVal;
        this.quartile1 = json.quartile1 != null ? json.quartile1: json.Quartile1;
        this.median = json.median != null ? json.median: json.Median;
        this.quartile3 = json.quartile3 != null ? json.quartile3: json.Quartile3;
        this.upperVal = json.upperVal != null ? json.upperVal: json.UpperVal;
        this.mean = json.mean != null ? json.mean: json.Mean;
        this.color = json.color != null ? json.color : json.Color;
        this.categoryField = json.categoryField != null ? json.categoryField : json.CategoryField;
        
    }

}

// Gauge stuff

export class GaugeData{
    public showValue: boolean;
    public value: number;
    public majorUnit: number;
    public minorUnit: number;
    public max: number;
    public min: number;
    public ranges: GaugeRange[];

    constructor(json?: any){
        if(json == null || json == undefined){
            this.showValue = true;
            this.value = 0;
            this.max = 100;
            this.min = 0;
            this.majorUnit = null;
            this.minorUnit = 0;
            this.ranges = [];
            return;
        }

        this.showValue = json.showValue != null ? json.showValue : json.ShowValue;
        this.value = json.value != null ? json.value : json.Vaue;
        this.majorUnit = json.majorUnit != null ? json.majorUnit : json.MajorUnit;
        this.minorUnit = json.minorUnit != null ? json.minorUnit : json.MinorUnit;
        this.max = json.max != null ? json.max : json.Max;
        this.min = json.min != null ? json.min : json.Min;
        this.ranges = [];
        var ranges = json.ranges != null ? json.ranges : json.Ranges;
        if(ranges){
            ranges.forEach(range => {
                this.ranges.push(new GaugeRange(range));
            });
        }
    }
}

export class GaugeRange {
    public to: number;
    public from: number;
    public color: string;

    constructor(json?: any){
        if(json == null){
            this.to = null;
            this.from = null;
            this.color = "";
            return;
        }
        this.to = json.to != null ? json.to : json.To;
        this.from = json.from != null ? json.from : json.From;
        this.color = json.color != null ? json.color : json.Color;
    }
}



export enum ChartType {
    chart = 1,
    text,
    grid, 
    arcGauge,
    radialGauge,
    boxPlot
}

export enum ChartDataType {
    static = 1,
    user
}

export enum ChartTemplateType {
    cartesianHorizontalCategories = 1,
    cartesianVerticalCategories,
    cartesianScatter,
    pie
}

export enum SeriesType {
    bubble = 1,
    // candlestick, not yet
    bar,
    barStacked,
    donut,
    spline,
    splineArea,
    line,
    lineArea,
    pie,
    scatter,
    //rangeBar
}

export enum StrokeType {
    solid = 1,
    dash
}

export enum FigureIcon {
    undefined,
    trendingFlat,
    trendingUp,
    trendingDown
}

export enum FigureStyle {
    undefined,
    positive,
    negative
}

export enum AnnotationType {
    gridLine = 1,  // Horizontal or Vertical line that crosses entire chart
    plotLine,      // Horizontal or vertical STRIP that crosses entire chart
    // point annotations - not supported by android out of the box
    crosshair,     // Two crossing lines with a point at the intersection
    bubble         // Balloon like shape with text next to point
}

export class ChartUtil {

    public static DefaultPalette = ["#489F50", "#3193EE", "#6939B1", "#E2276B", "#FC5A33", "#FCC139"];

    public static getChartTypeDisplay(type: ChartType): string {
        switch (type) {
            case ChartType.chart:
                return "Chart";
            case ChartType.text:
                return "Text";
            case ChartType.grid:
                return "Grid";
            case ChartType.arcGauge:
                return "Arc Gauge";
            case ChartType.radialGauge:
                return "Radial Gauge";
            case ChartType.boxPlot:
                return "Box and Whisker";
            default:
                return "unknown";
        }
    }

    public static getChartDataTypeDisplay(type: ChartDataType): string {
        switch (type) {
            case ChartDataType.static:
                return "Static";
            case ChartDataType.user:
                return "User Based";
            default:
                return "unknown";
        }
    }

    public static getSeriesType(type: SeriesType): string {
        switch (type) {
            // case SeriesType.text:
            //     return "text";
            case SeriesType.line:
                return "line";
            case SeriesType.spline:
                return "line";
            case SeriesType.lineArea:
                return "area"
            case SeriesType.splineArea:
                return "area"
            case SeriesType.bar:
                return "column";
            case SeriesType.pie:
                return "pie";
            case SeriesType.donut:
                return "donut";
            case SeriesType.barStacked:
                return "column";
            case SeriesType.bubble:
                return "bubble";
            case SeriesType.scatter:
                return "scatter";
        }
    }

    public static getSeriesTypeDisplay(type: SeriesType): string {
        switch (type) {
            // case SeriesType.text:
            //     return "text";
            case SeriesType.line:
                return "line";
            case SeriesType.spline:
                return "spline";
            case SeriesType.lineArea:
                return "line with area"
            case SeriesType.splineArea:
                return "spline with area"
            case SeriesType.bar:
                return "bar";
            case SeriesType.pie:
                return "pie";
            case SeriesType.donut:
                return "donut";
            case SeriesType.barStacked:
                return "stacked bar";
            case SeriesType.bubble:
                return "bubble";
            case SeriesType.scatter:
                return "scatter";
        }
    }


    public static getTemplateTypeDisplay(type: ChartTemplateType) {
        switch (type) {
            case ChartTemplateType.cartesianHorizontalCategories:
                return "Cartesian Horizontal Categories";
            case ChartTemplateType.cartesianVerticalCategories:
                return "Cartesian Vertical Categories";
            case ChartTemplateType.pie:
                return "Pie";
            case ChartTemplateType.cartesianScatter:
                return "Cartesian Scatter";
            default:
                return "Unknown";
        }
    }

    public static getTelerikChart(template: ChartTemplate, data: FilteredData) {
        template = new ChartTemplate(template);
        let tData = new TelerikData();

        if (!data || !data.data)
            return tData;

        for (let point of data.data[0].points) {
            tData.categories.push(point.category);
        }

        for (let seriesData of data.data) {
            if (template.series) {
                let seriesTemplate = template.series.find((ts) => ts.id == seriesData.seriesId);
                const series = new SeriesData(seriesData);
                if(seriesTemplate){
                    series.strokeType = seriesTemplate.strokeType;
                    series.typeString = this.getSeriesType(seriesTemplate.type);

                    if (seriesTemplate.type == SeriesType.splineArea) {
                        series.lineStyle = { style: 'smooth' }
                    }

                    if (seriesTemplate.type == SeriesType.spline) {
                        series.style = 'smooth';
                    }

                    if (seriesTemplate.type == SeriesType.barStacked) {
                        series.stacked = true;
                        series.dataPoints = new Array<any>();
                        for (let point of series.points) {
                            series.dataPoints.push(parseInt(point.value));
                        }
                    }

                    if ((seriesTemplate.type == SeriesType.bar || seriesTemplate.type == SeriesType.barStacked) && template.template == ChartTemplateType.cartesianVerticalCategories) {
                        series.typeString = 'bar';
                    }
                    tData.series.push(series);
                }
            }
        }
        return tData;
    }
}